import { createFileRoute, redirect } from "@tanstack/react-router";
import { OverallDashboard } from "../../components/dashboard/overall-dashboard";
import { hasSectorDashboards } from "../../lib/dashboard/sectors";

/** Overview · Dashboard — the four sectors at a glance, for the admins and a NOC (user, 2026-10-31). Anyone else goes to "/", which sends them to their own. */
export const Route = createFileRoute("/_app/dashboard/")({
	beforeLoad: ({ context }) => {
		if (!hasSectorDashboards(context.session)) throw redirect({ to: "/", replace: true });
	},
	staticData: { contentWidth: "full" },
	component: Page,
});

function Page() {
	const { session } = Route.useRouteContext();
	return <OverallDashboard session={session} />;
}
